/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Mute: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="mute" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M793.3475000000001 1255.2375V104.7625000000001L401.2000000000001 453.3475000000001H151.1300000000001V793.3475000000001C151.1300000000001 855.95 201.875 906.695 264.4775 906.695H401.2425L793.39 1255.28zM717.7825 1086.98L429.93 831.0875H264.4775C243.61 831.0875 226.695 814.1725 226.695 793.3050000000001V528.87H429.93L717.7825 272.9775V1086.9375zM1042.1425 680L936.615 785.5275L990.0375 838.95L1095.565 733.4225L1201.0925000000002 838.95L1254.515 785.5275L1148.9875000000002 680L1254.515 574.4725L1201.0925000000002 521.05L1095.565 626.5775L990.0375 521.05L936.615 574.4725L1042.1425 680z" : "M634.6780000000001 1004.19V83.81L320.9600000000001 362.6780000000001H120.904V634.6780000000001C120.904 684.7600000000001 161.5 725.356 211.582 725.356H320.9940000000001L634.712 1004.224zM574.226 869.584L343.944 664.87H211.582C194.888 664.87 181.356 651.338 181.356 634.644V423.096H343.944L574.226 218.382V869.55zM833.714 544L749.292 628.422L792.0300000000001 671.1600000000001L876.4520000000001 586.738L960.8740000000003 671.1600000000001L1003.6120000000002 628.422L919.1900000000002 544L1003.6120000000002 459.578L960.8740000000003 416.8399999999999L876.4520000000001 501.2619999999999L792.0300000000001 416.8399999999999L749.292 459.578L833.714 544z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Mute.displayName = `Blueprint5.Icon.Mute`;
export default Mute;
